import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { CalloutComponent, CalloutOptions } from 'components/callout/callout.component';
import { environment } from 'environments/environment';
import { ClickOutsideDirective } from 'weavix-shared/directives/click-outside.directive';
import { TranslationService } from 'weavix-shared/services/translation.service';
import { css } from 'weavix-shared/utils/css';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from 'components/icon/icon.component';

export interface MapControl {
    id: string;
    onClick?: () => void;
    tooltip: string;
    icon: string;
    iconHover?: string;
    isActive?: () => boolean;
    hide?: () => boolean;
    disabled?: () => boolean;
    disabledDefaultValue?: boolean;
    disabledTooltip?: string;
    color?: string;
    callout?: CalloutOptions;
    options?: MapControl[];
}

@Component({
    selector: 'app-map-control',
    templateUrl: './map-control.component.html',
    styleUrls: ['./map-control.component.scss', './map-control-teams.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MatTooltipModule,
        TranslateModule,

        ClickOutsideDirective,
        CalloutComponent,
        IconComponent,
    ],
})
export class MapControlComponent implements OnInit {
    teamsApp = environment.teamsApp;
    @Input() control: MapControl;
    displayOptions: boolean = false;
    colors = css.colors;
    buttonHovers: { [id: string]: boolean } = {};

    constructor(public translateService: TranslationService) {}

    ngOnInit() {
        if (this.teamsApp) this.control.color = null;
    }

    toggleOptions() {
        this.displayOptions = !this.displayOptions;
    }

    closeOptions(): void {
        this.displayOptions = null;
    }

    handleControlOptionClick(option: MapControl): void {
        if (this.isOptionDisabled(option)) return;
        option?.onClick();
    }

    isOptionDisabled(option: MapControl): boolean {
        return option?.disabled?.();
    }

    getTooltipTextKey(option: MapControl): string {
        if (this.isOptionDisabled(option)) {
            return option.disabledTooltip || 'shared.map.controls.disabled';
        }
        return '';
    }
}
